/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

/**
 * Get unix timestamp in seconds
 *
 */
export function getUnixtime() {
  return Math.floor(Date.now() / 1000);
}
